// Mind2Magic CRM — Module Entry Point
// Imports all modules as they are extracted from index.html.
// CSS is loaded via <link> in index.html (render-blocking, avoids FOUC).

// Constants & Store
import * as C from './constants.js'
import { store } from './store.js'

// Supabase (npm replaces CDN)
import './supabase/client.js'   // creates sb, sets window.sb
import './supabase/db.js'       // creates supabaseDB, sets window.supabaseDB

// Utilities (register on window for inline module)
import './utils/date.js'        // parseExcelDate, daysBetween, TODAY
import './utils/format.js'      // fmt, fmtDate, fmtUSD, escHtml, normalizePhone, etc.
import './utils/business.js'    // getType, calcProgress, findDup*, etc.

// History & Undo/Redo
import './history.js'           // saveState, undo, redo, addHistorial, _snapLead, _buildCambios, etc.

// UI (theme, toast, modal, zoom, font scale)
import './ui.js'                // applyTheme, toggleTheme, toast, openModal, closeModal, zoom*, etc.

// Settings, Hitos, Plantillas, Auth helpers
import './settings.js'          // loadSettings, saveSettings, openSettings, plantillas, togglePasswordVisibility, etc.

// Import modules (Excel, Typeform, PDF, Thunder)
import './import/excel.js'      // handleFile, processWorkbook, confirmImport, etc.
import './import/typeform.js'   // handleTypeformFile, showTfWizard, executeTfImport, etc.
import './import/pdf.js'        // handlePDFFile, parsePDFContent, createLeadFromPDF, etc.
import './import/thunder.js'    // detectThunderStaffing, processThunderImport, etc.

// Empresas (B2B)
import './empresas.js'         // switchCrmMode, renderEmpPipeline, saveBooking, renderInvoice, etc.

// Duplicate Scanner
import './dupscanner.js'       // scanDuplicates, mergeDupGroup, mergeAllDuplicates, etc.

// Pipeline & Views
import './pipeline.js'         // renderPipeline, renderCard, applyFilters, setupDragDrop, etc.

// Hitos Modal & Form Analytics
import './hitos-forms.js'      // openHitosModal, renderDashboard, renderFormularios, refreshFormSubmissions, etc.

// KPIs
import './kpis.js'             // renderKPIs, setKPIPeriod, toggleKPICompare

// Lead Management
import './leads.js'            // openLead, saveLead, saveLeadEdit, deleteLead, etc.

// Guide Planner, Trip View, Team & Viajeros
import './guide-trip.js'       // generateGuideLink, openTripView, openPanel, saveViajeros, etc.

// Guide PDF Generator (personalized cruise/trip guides)
import './guide-pdf.js'        // showGuideModal, generateGuide

// Content intelligence
import './content.js'          // renderContenido, showContentDraft, copyContentDraft

// WhatsApp conversation view
import './whatsapp.js'         // renderWhatsAppSection, loadWhatsAppMessages

// Itinerary Premium (Magic Planner 1.5 — DOCX generation, re-upload, PDF, learning)
import './itinerary/itinerary-ui.js'   // renderItinerarySection, openItineraryConfig, etc.
import './itinerary/pdf-finalizer.js'  // generateFinalPdf, downloadFinalPdf, generateDirectPdf (overrides itinerary-ui placeholders)
import './itinerary/learning.js'       // trackEdit, getLearnedPatterns (lazy: docx-generator, docx-parser)

// Calendar, Tareas, Comentarios & Cotizaciones
import './calendar-features.js' // renderCalendario, renderTareas, sendWhatsApp, exportToExcel, etc.

// Sync engine (loadFromSupabase, sync*, realtime subscriptions)
import './sync.js'

// Selection mode (bulk select, drag select, mass stage/responsable)
import './selection.js'

// Orchestrator (renderAll, showView)
import './orchestrator.js'

// Auth & Init (login, session check, initApp, logout, init calls)
// NOTE: Must be LAST — IIFE and init calls run at import time
import './auth.js'

// Make constants available globally for the inline module script
Object.assign(window, C)
window._m2m = { store, constants: C }

console.log('[CRM] Vite module system loaded')
